import { css } from 'linaria';

export const button = css`
  all: unset !important;
  cursor: pointer !important;
`;

export const root = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 112px;
  background: url('https://cdn.lemanapro.ru/lmru/image/upload/v1754477568/fudzi/navigation-microfronts/push-promo-background.svg/push-promo-background.svg')
    center center / cover no-repeat;
  border-radius: var(--rounding-l);
  white-space: pre;
  overflow: hidden;

  @media (--only-tablet) {
    height: 94px;
    border-radius: 10px;
  }

  @media (--from-desktop) {
    height: 88px;
    border-radius: 6px;
  }
`;

export const left = css`
  width: 184px;
  padding: var(--space-225);
  padding-right: 0;

  @media (--only-tablet) {
    width: 284px;
    padding: var(--space-250);
  }

  @media (--from-desktop) {
    width: 150px;
    padding: var(--space-175);
    padding-right: 0;
  }
`;

export const right = css`
  position: relative;
  width: 148px;
  height: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 10px;
    right: 30px;
    width: 100px;
    height: 110px;
    background: url('https://cdn.lemanapro.ru/lmru/image/upload/v1754410430/fudzi/navigation-microfronts/push-promo-phone.svg/push-promo-phone.svg')
      center center / contain no-repeat;

    @media (--only-tablet) {
      top: 6px;
      right: 120px;
      width: 130px;
      background-position: center 0;
      background-size: cover;
    }

    @media (--from-desktop) {
      top: -2px;
      right: 34px;
      width: 74px;
    }
  }

  &::after {
    position: absolute;
    right: 14px;
    bottom: 4px;
    width: 55px;
    height: 43px;
    background: url('https://cdn.lemanapro.ru/lmru/image/upload/v1754410354/fudzi/navigation-microfronts/push-promo-percent.svg/push-promo-percent.svg')
      center center / cover no-repeat;
    content: '';

    @media (--only-tablet) {
      top: 34px;
      right: 20px;
      width: 96px;
      height: 76px;
    }

    @media (--from-desktop) {
      right: 22px;
      width: 44px;
      height: 34px;
    }
  }

  @media (--only-tablet) {
    width: 272px;
  }
`;

export const title = css`
  span {
    font-size: 23px !important;
    line-height: 100% !important;

    @media (--only-mobile) {
      margin-bottom: var(--space-50);
    }

    @media (--only-tablet) {
      margin-bottom: var(--space-75);
      font-size: 25px !important;
    }

    @media (--from-desktop) {
      font-size: 15px !important;
    }

    @media (--from-largeDesktop) {
      font-size: 18px !important;
    }
  }
`;

export const text = css`
  @media (--from-desktop) {
    font-size: 14px !important;
  }

  @media (--from-largeDesktop) {
    font-size: 16px !important;
  }
`;

export const container = css`
  display: flex;
  align-items: center;
  width: 148px;
  height: 34px;
  margin: var(--space-475) 0 0 -12px;
  padding: var(--space-100) 0 var(--space-100) var(--space-100);
  background: linear-gradient(
    93deg,
    rgba(255, 255, 255, 0.88) 2.41%,
    rgba(255, 255, 255, 0.95) 79.41%,
    rgba(255, 247, 213, 0.95) 98.89%
  );
  border-radius: var(--rounding-l);
  backdrop-filter: blur(1.2px);

  @media (--only-tablet) {
    width: 182px;
    height: 42px;
    padding: var(--space-125) 0 var(--space-125) var(--space-125);
    margin: var(--space-350) 0 0 -6px;
  }

  @media (--from-desktop) {
    width: 120px;
    height: 28px;
    padding: var(--space-85) 0 var(--space-85) var(--space-85);
    margin: var(--space-350) 16px 0 0;
  }

  @media (--from-largeDesktop) {
    width: 130px;
    margin: var(--space-350) 0 0 var(--space-100);
  }
`;

export const containerText = css`
  @media (--only-tablet) {
    font-size: 15px !important;
  }

  @media (--from-desktop) {
    font-size: 10px !important;
  }
`;

export const nut = css`
  width: 12px;
  height: 12px;
  margin-right: var(--space-75);
  background: url('https://cdn.lemanapro.ru/lmru/image/upload/v1754407797/fudzi/navigation-microfronts/push-promo-nut.svg/push-promo-nut-icon.svg')
    center center / cover no-repeat;
`;
